import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CatalogPayableScheme} from './catalog-payable-scheme.model';
import * as CatalogPayableSchemeActions from './catalog-payable-scheme.actions';

export const catalogPayableSchemesFeatureKey = 'catalogPayableSchemes';

export interface State extends EntityState<CatalogPayableScheme> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CatalogPayableScheme> = createEntityAdapter<CatalogPayableScheme>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CatalogPayableSchemeActions.addCatalogPayableScheme,
    (state, action) => adapter.addOne(action.catalogPayableScheme, state)
  ),
  on(CatalogPayableSchemeActions.upsertCatalogPayableScheme,
    (state, action) => adapter.upsertOne(action.catalogPayableScheme, state)
  ),
  on(CatalogPayableSchemeActions.addCatalogPayableSchemes,
    (state, action) => adapter.addMany(action.catalogPayableSchemes, state)
  ),
  on(CatalogPayableSchemeActions.upsertCatalogPayableSchemes,
    (state, action) => adapter.upsertMany(action.catalogPayableSchemes, state)
  ),
  on(CatalogPayableSchemeActions.updateCatalogPayableScheme,
    (state, action) => adapter.updateOne(action.catalogPayableScheme, state)
  ),
  on(CatalogPayableSchemeActions.updateCatalogPayableSchemes,
    (state, action) => adapter.updateMany(action.catalogPayableSchemes, state)
  ),
  on(CatalogPayableSchemeActions.deleteCatalogPayableScheme,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CatalogPayableSchemeActions.deleteCatalogPayableSchemes,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CatalogPayableSchemeActions.loadCatalogPayableSchemes,
    (state, action) => adapter.setAll(action.catalogPayableSchemes, state)
  ),
  on(CatalogPayableSchemeActions.clearCatalogPayableSchemes,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
